import { UserEffects } from './notifications.effects';

export const effects: any[] = [UserEffects];

export * from './notifications.effects';
